import { render, staticRenderFns } from "./ClassMetricsGraph.vue?vue&type=template&id=172fe22f&lang=pug&"
import script from "./ClassMetricsGraph.vue?vue&type=script&lang=ts&"
export * from "./ClassMetricsGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports